/* Infinity Home · Notte di Halloween 2026 (Soleo Digital)
   Lo carica snippets/ih-notte-testa solo fino alla fine della promo.
   Fa cinque cose, e solo se la pagina è "di notte" (html.ih-notte):
     1. conti alla rovescia; a fine promo spegne la notte e la casa torna quella di sempre;
     2. i bottoni che copiano HALLOWEEN20;
     3. la barra del carrello verso i 50 € (a ogni modifica del carrello);
     4. il biglietto della pagina prodotto, che segue la variante e il carrello;
     5. i kit "Arriva a 50 €": tutto il kit nel carrello con un clic.
   Niente librerie. */
(function () {
  'use strict';
  var radice = document.documentElement;
  if (window.__ihNotte || !radice.classList.contains('ih-notte')) return;
  window.__ihNotte = true;

  var conf = window.IH_NOTTE || {};
  var FINE = conf.fine || 1793573999000;
  var CODICE = conf.codice || 'HALLOWEEN20';
  var SOGLIA = conf.soglia || 5000;
  var QUOTA = 1 - (conf.sconto || 20) / 100;

  function tutti(sel, dove) { return Array.prototype.slice.call((dove || document).querySelectorAll(sel)); }
  function due(n) { return (n < 10 ? '0' : '') + n; }
  function soldi(cents) {
    var v = (Math.max(0, Math.round(cents)) / 100).toFixed(2).split('.');
    return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function radiceUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- 1. il tempo ---------- */
  function spegni() { radice.classList.remove('ih-notte'); }
  if (Date.now() >= FINE) { spegni(); return; }

  function resto() { return Math.max(0, Math.floor((FINE - Date.now()) / 1000)); }
  function batti() {
    var r = resto();
    tutti('[data-ihn-conto]').forEach(function (c) {
      var p = { g: Math.floor(r / 86400), o: Math.floor((r % 86400) / 3600), m: Math.floor((r % 3600) / 60), s: r % 60 };
      Object.keys(p).forEach(function (k) {
        var el = c.querySelector('[data-ihn-' + k + ']');
        if (el) el.textContent = due(p[k]);
      });
    });
    tutti('[data-ihn-conto-breve]').forEach(function (el) {
      el.textContent = Math.floor(r / 86400) + 'g ' + due(Math.floor((r % 86400) / 3600)) + 'h ' + due(Math.floor((r % 3600) / 60)) + 'm';
    });
    if (r <= 0) { spegni(); return; }
    window.setTimeout(batti, 1000 - (Date.now() % 1000) + 10);
  }
  batti();

  /* l'apertura della home riempie lo schermo che resta sotto la testata */
  tutti('[data-ihn-ap]').forEach(function (sez) {
    var largo = 0;
    function misura(forza) {
      if (!forza && window.innerWidth === largo) return;
      largo = window.innerWidth;
      var sopra = sez.getBoundingClientRect().top + window.scrollY;
      /* sul telefono la testata è alta: l'apertura prende tutto lo schermo, la pentola resta sopra i bottoni */
      var alta = window.innerWidth < 750 ? Math.max(600, window.innerHeight) : Math.max(560, window.innerHeight - sopra);
      sez.style.setProperty('--ihn-ap-h', alta + 'px');
    }
    misura(true);
    window.setTimeout(function () { misura(true); }, 1200);
    window.addEventListener('resize', function () { misura(false); }, { passive: true });
  });

  /* ---------- 2. copia il codice (delegato: vale anche nel carrello ridisegnato) ---------- */
  function copiaAMano(testo) {
    var campo = document.createElement('textarea');
    campo.value = testo;
    campo.setAttribute('readonly', '');
    campo.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(campo);
    campo.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(campo);
    return ok;
  }
  function esito(bottone, riuscito) {
    var t = bottone.querySelector('[data-ihn-copia-testo]');
    if (t && !t.hasAttribute('data-ihn-orig')) t.setAttribute('data-ihn-orig', t.textContent);
    if (t) t.textContent = riuscito ? 'Copiato' : 'Scrivilo in cassa';
    bottone.classList.toggle('is-fatto', riuscito);
    window.clearTimeout(bottone.__ihnAttesa);
    bottone.__ihnAttesa = window.setTimeout(function () {
      if (t) t.textContent = t.getAttribute('data-ihn-orig');
      bottone.classList.remove('is-fatto');
    }, 2400);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ihn-copia]');
    if (!b) return;
    var codice = b.getAttribute('data-ihn-copia') || CODICE;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codice).then(function () { esito(b, true); }, function () { esito(b, copiaAMano(codice)); });
    } else {
      esito(b, copiaAMano(codice));
    }
  });

  /* ---------- 3 e 4. il carrello, la barra, il biglietto prodotto ---------- */
  var subtotale = null;

  function disegnaSoglia() {
    if (subtotale === null) return;
    var manca = SOGLIA - subtotale;
    tutti('[data-ihn-soglia]').forEach(function (box) {
      var frase = box.querySelector('[data-ihn-cs-frase]');
      var pieno = box.querySelector('[data-ihn-cs-pieno]');
      var barra = box.querySelector('[data-ihn-cs-barra]');
      box.classList.toggle('is-sopra', manca <= 0);
      if (frase) {
        frase.innerHTML = manca > 0
          ? 'Ti mancano <b>' + soldi(manca) + '</b> per il −20% con ' + CODICE + '.'
          : 'Con ' + CODICE + ' risparmi <b>' + soldi(subtotale * (1 - QUOTA)) + '</b> su questo carrello.';
      }
      if (pieno) pieno.style.setProperty('--p', Math.min(1, subtotale / SOGLIA).toFixed(3));
      if (barra) barra.setAttribute('aria-valuenow', Math.min(50, Math.floor(subtotale / 100)));
    });
    disegnaProdotto();
  }

  function leggiCarrello() {
    return fetch(radiceUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (c) { subtotale = c.items_subtotal_price || 0; disegnaSoglia(); return c; })
      .catch(function (err) { if (window.console) console.warn('[ih-notte] carrello non letto:', err); });
  }
  var attesaCarrello = null;
  function aggiorna() { window.clearTimeout(attesaCarrello); attesaCarrello = window.setTimeout(leggiCarrello, 250); }

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate || 'cart-update', aggiorna);
  }
  ['cart:updated', 'cart:refresh', 'product-ajax:added'].forEach(function (n) { document.addEventListener(n, aggiorna); });

  /* il biglietto della pagina prodotto */
  var biglietti = tutti('[data-ihn-prodotto]').map(function (el) {
    var mappa = {};
    try { mappa = JSON.parse((el.querySelector('[data-ihn-varianti]') || {}).textContent || '{}'); } catch (e) { mappa = {}; }
    return { el: el, mappa: mappa, id: el.getAttribute('data-ihn-variante') };
  });
  function disegnaProdotto() {
    biglietti.forEach(function (b) {
      var v = b.mappa[b.id];
      var riga = b.el.querySelector('[data-ihn-pb-riga]');
      if (!v || !riga) return;
      var c = subtotale || 0;
      var tot = c + v.p;
      if (v.p >= SOGLIA) {
        riga.innerHTML = 'Da solo supera i 50 €: con ' + CODICE + ' in cassa scende a <b class="ihn-su">' + soldi(v.p * QUOTA) + '</b>.';
      } else if (c >= SOGLIA) {
        riga.innerHTML = 'Il tuo carrello è già sopra i 50 €: con ' + CODICE + ' il −20% vale anche su questo.';
      } else if (tot >= SOGLIA) {
        riga.innerHTML = 'Con questo il carrello arriva a <b>' + soldi(tot) + '</b>: sopra i 50 €, con ' + CODICE + ' hai il −20% su tutto.';
      } else {
        riga.innerHTML = 'Con questo il carrello arriva a <b>' + soldi(tot) + '</b>: ti mancano <b class="ihn-su">' + soldi(SOGLIA - tot) + '</b> per il −20% su tutto.';
      }
    });
  }
  function nuovaVariante(id) {
    if (!id) return;
    biglietti.forEach(function (b) { if (b.mappa[id]) b.id = String(id); });
    disegnaProdotto();
  }
  if (biglietti.length) {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange || 'variant-change', function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v && v.id) nuovaVariante(String(v.id));
      });
    }
    document.addEventListener('change', function (e) {
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      var campo = form && form.querySelector('[name="id"]');
      if (campo) window.setTimeout(function () { nuovaVariante(campo.value); }, 60);
    });
  }

  if (tutti('[data-ihn-soglia]').length || biglietti.length) leggiCarrello();

  /* ---------- 5. i kit: tutti i pezzi nel carrello ---------- */
  function sezioniDaRidisegnare() {
    var sezioni = [];
    radice.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sezioni } }));
    return sezioni;
  }
  function apriCarrello(cartJson) {
    var cassetto = document.querySelector('cart-drawer');
    if (!cassetto || (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.cartType === 'page')) {
      window.location.href = radiceUrl() + 'cart';
      return;
    }
    if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    if (typeof cassetto.show === 'function') cassetto.show();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ihn-kit]');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var ids = (b.getAttribute('data-ihn-kit') || '').split(',').filter(Boolean);
    var stato = b.parentNode.querySelector('[data-ihn-kit-stato]');
    if (!ids.length) return;
    var sezioni = sezioniDaRidisegnare();
    b.setAttribute('aria-busy', 'true');
    b.classList.add('is-carica');
    if (stato) stato.textContent = '';
    fetch(radiceUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }),
        sections: sezioni,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Non è stato possibile aggiungere il kit.');
        return fetch(radiceUrl() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = res.j.sections;
          subtotale = cart.items_subtotal_price || 0;
          disegnaSoglia();
          if (stato) stato.textContent = 'Kit nel carrello. Totale carrello: ' + soldi(subtotale) + '.';
          apriCarrello(cart);
        });
      })
      .catch(function (err) {
        if (stato) stato.textContent = (err && err.message ? err.message : 'Qualcosa non ha funzionato.') + ' Riprova, oppure aggiungi i pezzi uno per uno.';
        if (window.console) console.warn('[ih-notte] kit:', err);
      })
      .finally(function () {
        b.removeAttribute('aria-busy');
        b.classList.remove('is-carica');
      });
  });
})();

/* Logo arancio durante la notte (anche dove il CSS content: url non basta). */
(function () {
  if (!document.documentElement.classList.contains('ih-notte')) return;
  var url = 'https://infinityhome.it/cdn/shop/files/infinity-home-logo-halloween.png?width=484';
  document.querySelectorAll('img[src*="Untitled_design_41"]').forEach(function (img) {
    img.removeAttribute('srcset');
    img.src = url;
  });
})();
